import { createRouter, createWebHashHistory } from 'vue-router'
import { EurekaSelectedModule, controlDeferred } from '@eureka/utils/control';
import HomeView from '../pages/home/index.vue';
import Report from '../pages/report/Report.vue';
import Chat from '../pages/create/Chat.vue';
import { loadI18n } from '@/infrastructure/locales';
import { isUserLogin } from '@eureka/utils/account';

const router = createRouter({
    history: createWebHashHistory(),
    routes: [
        {
            path: '/',
            redirect: '/list',
            beforeEnter: async(to, from, next) => {
                await loadI18n();
                next();
            },
            children: [
                {
                    path: 'list',
                    name: 'home',
                    component: HomeView,
                    beforeEnter: async(to, from, next) => {
                        const is_login = await isUserLogin()
                        if (is_login) {
                            const { is_air_product } = await controlDeferred.promise;
                            is_air_product ? next({ name: 'chat' }) : next();
                        } else {
                            next()
                        }
                    },
                },
                {
                    path: 'report/:projectId',
                    name: 'report',
                    component: Report,
                }, {
                    path: 'chat',
                    name: 'chat',
                    component: Chat,
                }, {
                    path: 'chat/:projectId',
                    name: 'chatDetail',
                    component: Chat,
                }
            ],
        }
    ],
})

export default router
